import React, {Component} from 'react'
import fire from '../../../../../database/firebase'
import styled from 'styled-components'
import GridLoader from "react-spinners/GridLoader";
import Tabs, {Tab} from 'react-best-tabs';
import 'react-best-tabs/dist/index.css';
import Dialog from 'rc-dialog';
import 'rc-dialog/assets/index.css';
import { ClipLoader } from 'react-spinners';


const Container = styled.div`
    width: 100%;
    height: auto;
    background-color: #321d05;
    //   padding: 1%;
    position: relative; /* Position relative to contain the dropdown */
    text-align: right;
    border-bottom: 0.5px solid white;
    padding-bottom: 2%;
`;

const Button = styled.button`
    background-color: #007bff;
    color: #fff;
    padding-left: 4%;
    padding-right: 4%;
    cursor: pointer;
    padding-top: 0px;
    padding-bottom: 0px;
    margin-right: 3.5%;
    background-color: #321d05;
    border-radius: 8px;
    border: 1px solid white;
    margin-top: 4%;
`;

const Dropdown = styled.div`
    position: absolute;
    top: 100%; /* Position the dropdown below the button */
    left: 0;
    width: 96%; /* Expand the dropdown to the full width of the container */
    display: ${props => (props.open ? 'block' : 'none')}; /* Show/hide the dropdown */
    background-color: #321d05;
    color: #fff;
    padding: 10px;
    //   border: 0.7px solid white;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    font-family: sora;
    // border-bottom-left-radius: 10px;
    // border-bottom-right-radius: 10px;
    transition: max-height 0.3s ease-in, opacity 0.3s ease-in; /* Add transitions */
    max-height: ${props => (props.open ? '200px' : '0')}; /* Set max-height for smooth expansion and collapse */
    overflow: hidden; /* Hide overflow content */
    opacity: ${props => (props.open ? '1' : '0')}; /* Set opacity for fade-in and fade-out */
`;

const Styles = styled.div `

    // - - FULL PAGE - - //

.fullPage {
    width: 100%;
    height: auto;
}

    // - - - NAVBAR - - //

.menu-btn {
    width: 25px;
    height: 25px;
}

    // - - - - - CHALLENGES PAGE - - - - - //

.challengesPage {
    margin-top: 2.5%;
}

    // - - CHALLENGES PAGE HEADER - - //

.challengesPageHeader {
    text-align: right;
}

.challengesPageHeader h1 {
    margin-left: 2%;
    font-family: sora;
}

.challengesPageHeader button {
    margin-right: 3.5%;
    width: 35%;
    background-color: #FF914D;
    color: #321d05;
    font-family: sora;
    font-size: 90%;
    padding: 2.5%;
    border-radius: 8px;
    border: 2px solid #FF914D
}

.challengesPageHeader button:hover {
    // color: white;
    // background-color: #0930cb;
    // border: 2px solid #0930cb;
}

    // - - REWARDS PAGE LOADING - - //

.challengesPageLoading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 75vh; /* This will make the container take the full viewport height */
    text-align: center;
}

    // - - ORDER CELL - - //

.orderCell {
    text-align: left;
    border-bottom: 1px solid black;
}

.orderCell p {
    font-family: sora;
}

    // - - ORDERS EMPTY - - //

.ordersEmptyImg {
    text-align: center;
}

.ordersEmptyImg img {
    width: 25%;
    margin-top: 14.5%;
}

`

export default class ChallengesSmPhone extends Component {
    constructor() {
        super()
        this.state = {
            userID: "",
            phoneNumber: "",
            currentClient: "",
            placeholderText: "",
            showChallengesPage: false,
            showChallengesPageLoading: true,
            showMyOrders: false,

            showPendingOrders: true,
            showPendingOrdersLoading: false,
            receiptID: "",

            showOrderSelected: false,
            showOrderDialogLoading: true,
            showOrderDialog: false,
            pendingOrders: [],
            approvedOrders: [],
            ordersHeader: "",
            selectedOrderReceipt: "",
            adminMsg: ""
            
        }
    }

    componentDidMount = () => {
        const url = window.location.href
        const parts = url.split('/'); // Split the URL by '/'
        const lastPart = parts[parts.length - 1]; // Get the last part
        this.setState({
            currentClient: lastPart
        })
        this.loadChallengesPage(lastPart)
    }

    loadChallengesPage = (client) => {
        fire.auth().onAuthStateChanged((user) => {
            if (user) {
                fire.firestore().collection("clients")
                .doc(client)
                .collection("members")
                .doc("members_list")
                .collection("email_list")
                .doc(user.email)
                .get().then(doc => {
                    if (doc.exists) {
                        this.setState({
                            userID: doc.data().id,
                            phoneNumber: doc.data().number
                        })
                        this.loadDatabaseInformation(client, doc.data().id)
                        this.loadPendingOrders(doc.data().id)
                    }
                })
            } else {
                console.log("We failed dawg")
                this.setState({user:null})
            }
        })
        this.setState({
            showChallengesPageLoading: true
        }, () => {
            setTimeout(() => {
               this.setState({
                showChallengesPageLoading: false,
                showChallengesPage: true,
                showMyOrders: true
               })
            }, 2500)
        })
    }

    loadDatabaseInformation = (client, userID) => {
        fire.firestore().collection("clients")
        .doc(client)
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(userID)
        .collection("data")
        .doc("challenges")
        .collection("list")
        .doc("placeholder")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    placeholderText: doc.data().text
                })
            }
        })
    }

    toggleDropdown = () => {
        this.setState((prevState) => ({
          isDropdownOpen: !prevState.isDropdownOpen,
        }));
    };

    exitChallengesPage = () => {
        this.setState({
            showChallengesPage: false,
            showMyOrders: false,
            showChallengesPageLoading: true
        }, () => {
            setTimeout(() => {
               this.setState({
                showChallengesPageLoading: false,
               })
               window.location.href = `/home/${this.state.currentClient}`
            }, 2500)
        })
    }

    loadPendingOrders = (userID) => {
        class Order {
            constructor (adminMsg, location, receiptID, receiptImg, uploadTime, userID, verified) {
                this.adminMsg = adminMsg
                this.location = location
                this.receiptID = receiptID
                this.receiptImg = receiptImg
                this.uploadTime = uploadTime
                this.userID = userID
                this.verified = verified
            }
            toString () {
                return this.adminMsg + ', ' +
                this.location + ', ' +
                this.receiptID + ', ' + 
                this.receiptImg + ', ' +
                this.uploadTime + ', ' +
                this.userID + ', ' +
                this.verified
            }
        }
        var orderConverter = {
            toFirestore : function(order) {
                return {
                    adminMsg: order.adminMsg,
                    location: order.location,
                    receiptID: order.receiptID,
                    receiptImg: order.receiptImg,
                    uploadTime: order.uploadTime,
                    userID: order.userID,
                    verified: order.verified
                }
            },
            fromFirestore : function (snapshot, options) {
                const data = snapshot.data(options)
                return new Order(data.adminMsg, data.location, data.receiptID, data.receiptImg, data.uploadTime, data.userID, data.verified)
            }
        }
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(userID)
        .collection("data")
        .doc("purchaseHistory")
        .collection("nonVerified")
        .withConverter(orderConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            console.log(data)
            this.setState({
                pendingOrders: data
            })
        })
    }

    loadApprovedOrders = (userID) => {
        class Order {
            constructor (date, location, receiptID, receiptImg) {
                this.date = date
                this.location = location
                this.receiptID = receiptID
                this.receiptImg = receiptImg
            }
            toString () {
                return this.date + ', ' +
                this.location + ', ' +
                this.receiptID + ', ' + 
                this.receiptImg + ', ' 
            }
        }
        var orderConverter = {
            toFirestore : function(order) {
                return {
                    date: order.date,
                    location: order.location,
                    receiptID: order.receiptID,
                    receiptImg: order.receiptImg,
                }
            },
            fromFirestore : function (snapshot, options) {
                const data = snapshot.data(options)
                return new Order(data.date, data.location, data.receiptID, data.receiptImg)
            }
        }
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(this.state.userID)
        .collection("data")
        .doc("purchaseHistory")
        .collection("verified")
        .withConverter(orderConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            this.setState({
                approvedOrders: data
            })
        })
    }

    pendingOrderClicked = (receiptImg, adminMsg, receiptID) => {
        if (adminMsg !== "") {
            this.setState({
                showErrorTitle: true,
                showReceiptDeleteBtn: true
            })
        } else {
            this.setState({
                 showErrorTitle: false
            })
        }
        this.setState({
            receiptID: receiptID,
            showOrderSelected: true,
            ordersHeader: "Receipt",
            selectedOrderReceipt: receiptImg,
            showOrderDialogLoading: true,
            adminMsg: adminMsg
        }, () => {
            setTimeout(() => {
               this.setState({
                showOrderDialogLoading: false,
                showOrderDialog: true,
               })
            }, 2000)
        })
    }

    closeOrderDialog = () => {
        this.setState({
            showOrderSelected: false,
            showOrderDialog: false
        })
    }

    renderPendingOrders = () => {
        if (this.state.pendingOrders.length !== 0) {
            return this.state.pendingOrders.map(orders => {
                var {adminMsg, location, receiptID, receiptImg, uploadTime, userID, verified} = orders
        
                let date = uploadTime.split(' ')[0];
                let time = uploadTime.split(' ')[1];

                let dateComponents = date.split('-');
                let timeComponents = time.split('-');

                let orderDate = `${dateComponents[1]}/${dateComponents[2]}/${dateComponents[0]} (${timeComponents[0]}:${timeComponents[1]})`

                let pendingTitle
                if (adminMsg === "") {
                    pendingTitle = "Pending Approval"
                } else {
                    pendingTitle = "Receipt Not Approved"
                }
                

                return (
                    <div onClick={() => this.pendingOrderClicked(receiptImg, adminMsg, receiptID)} style={{paddingBottom: "4.5%"}} className='orderCell'>
                        <div style={{display: "flex", justifyContent: "space-between"}}>
                            <p style={{marginBottom: "1.5%",}}>{pendingTitle}</p>
                        </div>
                        <label style={{color: "#0930cb", fontFamily: "rubik"}}><span style={{fontWeight: "bold", fontFamily: "gabarito", color: "#000"}}>Submitted:</span> {orderDate}</label>
                    </div>
                )
            })
        } else {
            return (
                <div className='ordersEmpty'>
                    <h2 style={{fontFamily: "rubik", color: "#321d05"}}>All orders are up to date</h2>
                    <div className='ordersEmptyImg'>
                        <img src='/assets/smallPhone_upToDatePending2.png'/>
                    </div>
                </div>
            )
        }
    }

    renderApprovedOrders = () => {
        if (this.state.approvedOrders.length !== 0) {
            return this.state.approvedOrders.map((orders, index)=> {
                var {date, location, receiptID, receiptImg} = orders

                let dateComponents = receiptID.split('-');

                let orderDate = `${dateComponents[3]}/${dateComponents[2]}/${dateComponents[1]} (${dateComponents[4]}:${dateComponents[5]})`

                let adminMsg = ""

                return (
                    <div onClick={() => this.pendingOrderClicked(receiptImg, adminMsg, receiptID)} style={{paddingBottom: "4.5%"}} className='orderCell'>
                        <div style={{display: "flex", justifyContent: "space-between"}}>
                            <p style={{marginBottom: "1.5%"}}>Order #{index+1}</p>
                        </div>
                        <label style={{color: "#0930cb", fontFamily: "rubik"}}><span style={{fontWeight: "bold", fontFamily: "gabarito", color: "#000"}}>Order date:</span> {orderDate}</label>
                    </div>
                )
            })
        } else {
            return (
                <div className='ordersEmpty'>
                    <h2 style={{fontFamily: "rubik", color: "#321d05"}}>No existing orders</h2>
                    <div className='ordersEmptyImg'>
                        <img src='/assets/smallPhone_approvedOrders.png'/>
                    </div>
                </div>
            )
        }
    }

    handleTabClick = (event, tab) => {
        if (tab === 2) {
            this.loadApprovedOrders()
            this.setState({
                showApprovedOrders: false,
                showApprovedOrdersLoading: true,
            }, () => {
                setTimeout(() => {
                   this.setState({
                        showApprovedOrdersLoading: false,
                        showApprovedOrders: true
                   })
                }, 2000)
            })
        } else if (tab === 1) {
            this.loadPendingOrders(this.state.userID)
            this.setState({
                showPendingOrders: false,
                showPendingOrdersLoading: true,
            }, () => {
                setTimeout(() => {
                   this.setState({
                        showPendingOrdersLoading: false,
                        showPendingOrders: true
                   })
                }, 2000)
            })
        }
    }

    deleteReceiptClicked = () => {
        this.setState({
            showReceiptDeleteBtn: false,
            showReceiptLoadingBtn: true
        }, () => {
            setTimeout(() => {
               this.setState({
                    showReceiptLoadingBtn: false,
                    showReceiptConfirmDelete: true
               })
            }, 2500)
        })
    }

    confirmReceiptDeleteClicked = () => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(this.state.userID)
        .collection("data")
        .doc("purchaseHistory")
        .collection("nonVerified")
        .doc(this.state.receiptID)
        .delete()
        this.setState({
            showReceiptConfirmDelete: false,
            showOrderDialog: false,
            showOrderDialogLoading: true
        }, () => {
            this.loadPendingOrders()
            setTimeout(() => {
               this.setState({
                    showOrderSelected: false
               })
            }, 2500)
        })
    }

    cancelReceiptDeleteClicked = () => {
        this.setState({
            showReceiptConfirmDelete: false,
            showReceiptLoadingBtn: true
        }, () => {
            this.loadPendingOrders()
            setTimeout(() => {
               this.setState({
                    showReceiptLoadingBtn: false,
                    showReceiptDeleteBtn: true
               })
            }, 2500)
        })
    }

    render () {

        const titleStyle = {
            // Add your custom font properties here
            fontFamily: 'rubik',
            fontSize: '16px', // Adjust the font size as needed
            fontWeight: 'bold', // Adjust the font weight as needed
            color: "#321d05",
            paddingTop: "0.5%"
            // Add other font properties as needed
        };

        return(
            <Styles>
                <div className='fullPage'>
                    <div className='navbar'>
                    <Container>
                            <div style={{display: "flex", justifyContent:"space-between"}}>
                                <h3 style={{paddingLeft: "4%", fontFamily: "sora", fontSize: "18.5px", fontWeight: "bold", paddingTop: "2%", color: "white"}}>My Orders <label style={{marginLeft: "5px"}}></label></h3>
                                <Button onClick={this.toggleDropdown}>
                                    <img className='menu-btn' src='/assets/mobile-smallphone-menu-icon.png'/>
                                </Button>
                            </div>
                            <Dropdown open={this.state.isDropdownOpen}>
                            <p style={{paddingRight: "2.5%"}}>Logout</p>
                            <p style={{paddingRight: "2.5%"}}>Back to Home</p>
                            {/* <p style={{paddingRight: "2.5%"}}>Rewards</p>
                            <p style={{paddingRight: "2.5%"}}>More Options</p> */}
                            </Dropdown>
                        </Container>
                    </div>
                    {this.state.showChallengesPage && 
                        <div className='challengesPage'>
                            <div className='challengesPageHeader'>
                                {/* <h1>Challenges</h1> */}
                                <button
                                onClick={this.exitChallengesPage}
                                >Back to Home</button>
                            </div>
                        </div>
                    }
                    {this.state.showMyOrders && 
                        <div style={{marginRight: "5%", marginLeft: "5%", marginTop: "5%"}}>
                            <Tabs
                            activeTab="1"
                            className="tabContainer"
                            ulClassName="underline"
                            activityClassName="theUnderline"
                            onClick={(event, tab) => this.handleTabClick(event,tab)}
                            >
                                <Tab title="Pending">
                                    {this.state.showPendingOrders && 
                                        <div style={{height: "100%", width: "100%", marginBottom: "15%", overflowY: "scroll"}}>
                                            {this.renderPendingOrders()}
                                        </div>
                                    }
                                    {this.state.showPendingOrdersLoading && 
                                        <div style={{textAlign: "center", marginTop: "20.5%"}}>
                                            <ClipLoader
                                            color="#321d05"
                                            loading={true}
                                            // cssOverride={override}
                                            size={30}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                            />
                                        </div>
                                    }
                                </Tab>
                                <Tab title='Approved'>
                                    {this.state.showApprovedOrders && 
                                        <div style={{height: "100%", width: "100%", marginBottom: "15%", overflowY: "scroll"}}>
                                            {this.renderApprovedOrders()}
                                        </div>
                                    }
                                    {this.state.showApprovedOrdersLoading && 
                                        <div style={{textAlign: "center", marginTop: "20.5%"}}>
                                            <ClipLoader
                                            color="#321d05"
                                            loading={true}
                                            // cssOverride={override}
                                            size={30}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                            />
                                        </div>
                                    }
                                </Tab>
                            </Tabs>
                        </div>
                    }
                    <Dialog
                    visible={this.state.showOrderSelected}
                    onClose={this.closeOrderDialog}
                    title={<div style={titleStyle}>{this.state.ordersHeader}</div>}
                    // style={{backgroundColor: "#f1f2f3"}}
                    >
                        {this.state.showOrderDialog && 
                            <div>
                                {this.state.showErrorTitle && 
                                    <div>
                                        {this.state.showReceiptDeleteBtn && 
                                            <div style={{textAlign: "right"}}>
                                                <button style=
                                                {{
                                                    backgroundColor: "#FF914D", 
                                                    padding: "3%", 
                                                    borderRadius: "8px", 
                                                    width: "40%",
                                                    color: "#321d05",
                                                    border: "2px solid #FF914D",
                                                    fontFamily: "rubik",
                                                    fontSize: "100%"
                                                }}
                                                onClick={this.deleteReceiptClicked}
                                                >Delete</button>
                                            </div>
                                        }
                                        {this.state.showReceiptLoadingBtn && 
                                            <div style={{textAlign: "right"}}>
                                                <button style=
                                                {{
                                                    backgroundColor: "#FF914D", 
                                                    padding: "3%", 
                                                    borderRadius: "8px", 
                                                    width: "40%",
                                                    color: "#321d05",
                                                    fontFamily: "rubik",
                                                    fontSize: "100%"
                                                }}>
                                                    <span style={{marginTop: "5%"}}>
                                                        <ClipLoader
                                                        color="#321d05"
                                                        loading={true}
                                                        // cssOverride={override}
                                                        size={10}
                                                        aria-label="Loading Spinner"
                                                        data-testid="loader"
                                                        />
                                                    </span>
                                                </button>
                                            </div>
                                        }
                                        {this.state.showReceiptConfirmDelete &&
                                            <div style={{display: "flex", justifyContent: "space-between", marginBottom: "1.5%"}}>
                                                <button style=
                                                {{
                                                    backgroundColor: "#dfdfdf", 
                                                    padding: "3%", 
                                                    borderRadius: "8px", 
                                                    width: "40%",
                                                    color: "red",
                                                    border: "2px solid #dfdfdf",
                                                    fontFamily: "rubik",
                                                    fontSize: "100%"
                                                }}
                                                onClick={this.cancelReceiptDeleteClicked}
                                                >Cancel</button>
                                                <button style=
                                                {{
                                                    backgroundColor: "#321d05", 
                                                    padding: "3%", 
                                                    borderRadius: "8px", 
                                                    width: "40%",
                                                    color: "white",
                                                    borde: "",
                                                    fontFamily: "rubik",
                                                    fontSize: "100%"
                                                }}
                                                onClick={this.confirmReceiptDeleteClicked}
                                                >Confirm</button>
                                            </div>
                                        }
                                        <p style={{fontFamily: "#0930cb", color: "#0930cb", fontWeight: "bold", marginTop: "0px", marginBottom: "0px"}}>RE:</p>
                                    </div>
                                    
                                }
                                <p style={{fontFamily: "rubik", marginTop: "1%"}}>{this.state.adminMsg}</p>
                                <img style={{width: "100%", height: "100%"}} src={this.state.selectedOrderReceipt}/>
                            </div>
                        }
                        {this.state.showOrderDialogLoading && 
                            <div style={{textAlign: "center", marginTop: "10%", marginBottom: "10%"}} className='challengesPageLoading'>
                                <ClipLoader
                                color="#321d05"
                                loading={true}
                                // cssOverride={override}
                                size={30}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                                />
                            </div>
                        }
                    </Dialog>
                    {this.state.showChallengesPageLoading && 
                        <div className='challengesPageLoading'>
                            <GridLoader
                            color="#321d05"
                            loading={true}
                            // cssOverride={override}
                            size={7.5}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                            />
                        </div>
                    }
                </div>
            </Styles>
        )
    }
}